import React from 'react';
import { TrophyOutlined } from '@ant-design/icons';

import modulesImage from '../../../../Assets/Linkages/WorldSpaceWeek/WSW-2026-Modules.jpg';
import WorldSpaceWeekLegacy from './WorldSpaceWeekLegacy';

const awards = [
  ['WSW 2026 Space Champion Award for Institute', 'Shield & Certificate', 'Institute Honor'],
  ['WSW 2026 Space Runner Up Award for Institute', 'Shield & Certificate', 'Institute Honor'],
  ['Winner Award for Winning Participant', 'Shield & Certificate', 'Participant Honor'],
  ['Runner Up Award for Runner Up Participant', 'Certificate', 'Participant Honor'],
  ['Space Ambassador Acknowledgement Award', 'Shield & Certificate', 'Ambassador Honor'],
  ['Participation Acknowledgement', 'Certificate', 'Recognition'],
];

const WorldSpaceWeek2026 = () => (
  <section className="wsw-2026" aria-labelledby="wsw-2026-title">
    <div className="wsw-2026-intro">
      <p className="section-eyebrow">ROCKET REVOLUTION</p>
      <h2 id="wsw-2026-title">World Space Week 2026</h2>
      <div className="world-space-week-title-line" aria-hidden="true" />
      <p>
        Institute of Space Technology (IST), Islamabad, through the Space Education Research Lab
        (SERL) of NCGSA, is organizing World Space Week 2026 on October 8–9, 2026 under the theme
        “Rocket Revolution.”
      </p>
      <p>
        WSW 2026 will bring together school and college students for 14 engaging modules covering
        rocketry, launch vehicles, space missions, engineering design, space heritage, creative arts,
        and AI-based activities. A special Workshop on Design &amp; Development of Sugar-Propelled
        Rocket will also be conducted as part of the celebrations.
      </p>
    </div>

    <figure className="wsw-2026-poster">
      <img src={modulesImage} alt="World Space Week 2026 Rocket Revolution modules" loading="lazy" />
    </figure>

    <WorldSpaceWeekLegacy />

    <div className="wsw-2026-programs">
      <article className="wsw-2026-card">
        <p className="section-eyebrow">LEARN · DESIGN · BUILD</p>
        <h3>WSW 2026 Modules</h3>
        <p>
          Explore all 14 modules, including technical presentations, project displays, rocketry
          activities, space heritage, visual arts, and AI-based modules.
        </p>
        <dl className="wsw-2026-facts">
          <div><dt>Eligibility</dt><dd>Grade 6–12</dd></div>
          <div><dt>Registration</dt><dd>Institutional</dd></div>
          <div><dt>Fee</dt><dd>PKR 10,000 per institute</dd></div>
        </dl>
        <div className="wsw-2026-actions">
          <a
            className="wsw-2026-action-primary"
            href="https://www.cognitoforms.com/GSERLNCGSA/WorldSpaceWeek2026EventRegistration"
            target="_blank"
            rel="noopener noreferrer"
          >
            Event Registration <span aria-hidden="true">↗</span>
          </a>
          <a
            className="wsw-2026-action-secondary"
            href="/documents/WSW-2026-List-of-Modules.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            List of Modules <span aria-hidden="true">↗</span>
          </a>
        </div>
      </article>

      <article className="wsw-2026-card">
        <p className="section-eyebrow">HANDS-ON ROCKETRY</p>
        <h3>Workshop on Design &amp; Development of Sugar-Propelled Rocket</h3>
        <p>
          Learn the fundamentals of model rocket design, propulsion, stability, structural
          components and launch preparation.
        </p>
        <dl className="wsw-2026-facts">
          <div><dt>Eligibility</dt><dd>Grade 9–12 &amp; undergraduate students</dd></div>
          <div><dt>Registration</dt><dd>Individual</dd></div>
          <div><dt>Fee</dt><dd>PKR 1,500 per participant</dd></div>
        </dl>
        <p className="wsw-2026-note">
          Students registered through their institute for WSW 2026 Modules may join the workshop
          without an additional workshop fee.
        </p>
        <div className="wsw-2026-actions">
          <a
            className="wsw-2026-action-primary"
            href="https://www.cognitoforms.com/GSERLNCGSA/WorldSpaceWeek2026WorkshopOnDesignDevelopmentOfSugarPropelledRocket"
            target="_blank"
            rel="noopener noreferrer"
          >
            Workshop Registration <span aria-hidden="true">↗</span>
          </a>
        </div>
      </article>
    </div>

    <div className="wsw-2026-registration">
      <header>
        <p className="section-eyebrow">SECURE YOUR PLACE</p>
        <h3>Registration &amp; Payment</h3>
        <div className="world-space-week-title-line" aria-hidden="true" />
        <p><strong>Registration deadline:</strong> October 2, 2026</p>
        <p>Registrations may close earlier if all available slots are filled.</p>
      </header>

    <div className="wsw-2026-details">
      <article className="wsw-2026-payment">
        <p className="section-eyebrow">PAYMENT DETAILS</p>
        <h3>IST Professional Development Center</h3>
        <dl>
          <div><dt>Account Title</dt><dd>IST Professional Development Center</dd></div>
          <div><dt>Account Number / IBAN</dt><dd>PK49JSBL9567000001894146</dd></div>
          <div><dt>Bank</dt><dd>JS Bank</dd></div>
          <div><dt>Address</dt><dd>Plot No. 4, Jinnah Blvd East, Sector A, Near Gate No. 1, DHA Phase II, Islamabad</dd></div>
        </dl>
      </article>

      <article className="wsw-2026-guide">
        <p className="section-eyebrow">QUICK REGISTRATION GUIDE</p>
        <h3>Choose Your Route</h3>
        <div>
          <strong>Participating as a school or college?</strong>
          <p>Pay PKR 10,000 once → Register your institute → Nominate students for WSW Modules.</p>
        </div>
        <div>
          <strong>Interested only in the Rocketry Workshop?</strong>
          <p>Register individually → Pay PKR 1,500 per participant.</p>
        </div>
        <div>
          <strong>Already registered for WSW Modules?</strong>
          <p>Register for the Rocketry Workshop → No additional workshop fee.</p>
        </div>
      </article>
    </div>
    </div>

    <div className="wsw-2026-awards">
      <header>
        <p className="section-eyebrow">CELEBRATING EXCELLENCE</p>
        <h3>Awards &amp; Honors</h3>
        <div className="world-space-week-title-line" aria-hidden="true" />
      </header>
      <div className="wsw-2026-awards-grid">
          {awards.map(([title, recognition, category], index) => (
            <article key={title}>
              <span className="wsw-award-category">{category}</span>
            <span className="wsw-award-number">{String(index + 1).padStart(2, '0')}</span>
            <TrophyOutlined className="wsw-award-icon" aria-hidden="true" />
            <h4>{title}</h4>
              <div className="wsw-award-recognition">
                <span aria-hidden="true" />
                <p>{recognition}</p>
              </div>
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default WorldSpaceWeek2026;
